// extracted by mini-css-extract-plugin
module.exports = {"IndustryLeadingD":"IndustryLeadingD_IndustryLeadingD__cSlLh"};